import React from 'react';

const Request = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <form action="" method="post" id="ChronoContact_request_information" name="ChronoContact_request_information">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <td className="bg-indigo-500 text-white p-4" colSpan="2">
                  <p className="font-bold">
                    Want to learn more about GWUA?<br /><br />
                    Fill out the form below as completely as possible and one of our staff will get in touch with you. Please be sure to indicate how you prefer to be contacted.
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="h-8"></td>
              </tr>
            </thead>
            <tbody className="text-sm">
              <tr>
                <td className="font-bold p-2">Name</td>
                <td className="p-2">
                  <input type="text" maxLength="1024" size="50" name="Name" id="Name" className="w-full border border-gray-300 rounded p-2" />
                </td>
              </tr>
              <tr>
                <td className="font-bold p-2">Address</td>
                <td className="p-2">
                  <input type="text" maxLength="1024" size="50" name="Address" id="Address" className="w-full border border-gray-300 rounded p-2" />
                </td>
              </tr>
              <tr>
                <td className="font-bold p-2">City, State, Zip</td>
                <td className="p-2">
                  <input type="text" maxLength="1024" size="50" name="CityStateZip" id="CityStateZip" className="w-full border border-gray-300 rounded p-2" />
                </td>
              </tr>
              {/* Add more form fields here */}
            </tbody>
          </table>
        </form>
      </div>
    </div>
  );
};

export default Request;